export const roleOrder=["axel","growth","research","paid-media","lifecycle","creative","operations"] as const;
export const departmentLayout:Record<string,[number,number,number]>={axel:[0,0,0],growth:[-6,0,-4],research:[0,0,-5.5],"paid-media":[6,0,-4],lifecycle:[-6,0,4],creative:[0,0,5.5],operations:[6,0,4]};
